/* eslint-disable */
export const user_comments: { [key: string]: Array<{ [key: string]: string }> } = {
    'es-AR': [
        {
            title: 'Confiable y segura',
            name: 'Victor Schiavina',
            content:
                'Es segura y confiable, he realizado varias transacciones con 100% de éxito. Las cotizaciones están bajas a mi parecer, para mandar pesos y recibir dólares vía Paypal, voy a esperar a después de las elecciones.',
            img: '/assets/landing-page/comments/intercambia-seguro-paypal-1-v2',
            link: 'https://maps.app.goo.gl/eo1Rt6GYAzqU9hZf7',
            alt: 'Victor Schiavina cambia saldo en Saldo.com.ar'
        },
        {
            title: 'Plataformas de cambio de divisas',
            name: 'Jhosmar Quintero',
            content:
                'Una de las mejores plataformas de cambio de divisas con las que he trabajado. Son muy atentos y responden en todo momento. 100% confiables.',
            img: '/assets/landing-page/comments/intercambia-seguro-paypal-v2',
            link: 'https://maps.app.goo.gl/r13UvKNrJJ3ZqVro9',
            alt: 'Jhosmar Quintero cambia saldo en Saldo.com.ar'
        },
        {
            title: 'Saldoar es práctico y fácil',
            name: 'Daniel Alfonso ',
            content:
                'Excelente, rapidisimo y con un buen precio, lo recomiendo por la agilidad con la pagina y por la respuesta rapida en el caso de alguna consulta. Además por la facilidad de monedas disponibles',
            img: '/assets/landing-page/comments/intercambia-seguro-paypal-2-v2',
            link: 'https://maps.app.goo.gl/6mps3SbTgX2K8b6b9',
            alt: 'Daniel Alfonso cambia saldo en Saldo.com.ar'
        },
        {
            title: 'Es una página muy confiable',
            name: 'Alejandro Nieva',
            content: 'Impecables , operaciones seguras , súper recomendable.',
            img: '/assets/landing-page/comments/intercambia-seguro-payoneer-v2',
            link: 'https://maps.app.goo.gl/gw2G6ybA7o9iS8Am7',
            alt: 'Alejandro Nieva cambia saldo en Saldo.com.ar'
        },
        {
            title: 'Fácil y 100% seguro',
            name: 'Adaliz Buitriago López',
            content:
                'Excelente servicio, altamente recomendable. Es bastante sencillo de utilizar y confiable, con una buena metodología para hacer el cambio de saldo, además es bastante rápido. Descubrí Saldoar a finales del año pasado y desde entonces es mi página favorita.',
            img: '/assets/landing-page/comments/intercambia-seguro-skrill-v2',
            link: 'https://maps.app.goo.gl/BLRbonSiW72sB7RH9',
            alt: 'Adaliz Buitriago López cambia saldo en Saldo.com.ar'
        },
        {
            title: 'Buen servicio y atención',
            name: 'Alicia Nicotera',
            content: 'Mucho tiempo que trabajo con ellos y son de diez!!!',
            img: '/assets/landing-page/comments/intercambia-seguro-skrill-1-v2',
            link: 'https://maps.app.goo.gl/C3cSCe9As3p4atCn6',
            alt: 'Alicia Nicotera cambia saldo en Saldo.com.ar'
        },
        {
            title: 'Rápidos y confiables',
            name: 'Florencia Aguirre Fernández',
            content:
                'Muy bueno...En cada proceso siempre te ayudan y eso es muy bueno...Lo recomiendo, en minutos pude hacer la transferencia, todo fue rápido y confiable',
            img: '/assets/landing-page/comments/intercambia-seguro-skrill-2-v2',
            link: 'https://maps.app.goo.gl/XzaEJRMBTvwEwQz3A',
            alt: 'Florencia Aguirre Fernández cambia saldo en Saldo.com.ar'
        },
        {
            title: 'Siempre excelente servicio.',
            name: 'Alfredo Lesquerre',
            content: 'Muy buena herramienta para mover fondos globalmente',
            img: '/assets/landing-page/comments/intercambia-seguro-transferencia-bancaria-v2',
            link: 'https://maps.app.goo.gl/vwXeLw1gEsk63Maf8',
            alt: 'Alfredo Lesquerre cambia saldo en Saldo.com.ar'
        },
        {
            title: 'Seguro, confiable y rápido.',
            name: 'Thiago Varas',
            content: 'Muy buen servicio, la rapidez para recibir los fondos es algo a destacar, unos capos la verdad',
            img: '/assets/landing-page/comments/intercambia-seguro-transferencia-bancaria-1-v2',
            link: 'https://maps.app.goo.gl/ZQE2MGTeqm3iyNVk7',
            alt: 'Thiago Varas cambia saldo en Saldo.com.ar'
        },
        {
            title: 'De confianza.',
            name: 'Brayan Torrealba',
            content:
                'La página más profesional que he conocido, responsables, atentos y con una diversidad de servicios.100% recomendados.',
            img: '/assets/landing-page/comments/intercambia-seguro-transferencia-bancaria-2-v2',
            link: 'https://maps.app.goo.gl/FhgqvwmQGZijHZJ16',
            alt: 'Brayan Torrealba cambia saldo en Saldo.com.ar'
        }
    ],
    'en-US': [
        {
            // prettier-ignore
            title: "It's honestly the best and fastest way...",
            name: 'Victor Schiavina',
            // prettier-ignore
            content:
                'It is safe and reliable, I have made several transactions with 100% success. The quotes are low in my opinion, to send pesos and receive dollars via Paypal, I will wait until after the elections.',
            img: '/assets/landing-page/comments/safe-change-skrill-1',
            link: 'https://maps.app.goo.gl/eo1Rt6GYAzqU9hZf7',
            alt: 'Victor Schiavina cambia saldo en Saldo.com.ar'
        },
        {
            title: 'Over 40 operations done and everytime GREAT…',
            name: 'Jhosmar Quintero',
            content: 'One of the best currency exchange platforms I have worked with, attentive responses at all times, 100% reliable.',
            img: '/assets/landing-page/comments/safe-change-paypal-9',
            link: 'https://maps.app.goo.gl/r13UvKNrJJ3ZqVro9',
            alt: 'Jhosmar Quintero cambia saldo en Saldo.com.ar'
        },
        {
            title: 'It is secure',
            name: 'Daniel Alfonso ',
            content:
                'Excellent, very fast and with a good price, I recommend it for the agility with the page and for the quick response in case of any query. Also for the ease of available currencies.',
            img: '/assets/landing-page/comments/safe-change-payoneer-ramdom',
            link: 'https://maps.app.goo.gl/6mps3SbTgX2K8b6b9',
            alt: 'Daniel Alfonso cambia saldo en Saldo.com.ar'
        },
        {
            title: 'Impeccable, safe operations.',
            name: 'Alejandro Nieva',
            content: 'Impeccable, safe operations, highly recommended.',
            img: '/assets/landing-page/comments/safe-change-paypal-8',
            link: 'https://maps.app.goo.gl/gw2G6ybA7o9iS8Am7',
            alt: 'Alejandro Nieva cambia saldo en Saldo.com.ar'
        },
        {
            title: 'Excellent service.',
            name: 'Adaliz Buitriago López',
            content:
                'Excellent service, highly recommended. It is quite easy to use and reliable, with a good methodology for changing balance, it is also quite fast. I discovered Saldoar at the end of last year and since then it has been my favorite page.',
            img: '/assets/landing-page/comments/safe-change-paypal-1',
            link: 'https://maps.app.goo.gl/BLRbonSiW72sB7RH9',
            alt: 'Adaliz Buitriago López cambia saldo en Saldo.com.ar'
        },
        {
            // prettier-ignore
            title: "They are great",
            name: 'Alicia Nicotera',
            content: "I've been working with them for a long time and they are great!!!",
            // prettier-ignore
            img: '/assets/landing-page/comments/safe-change-paypal-3',
            link: 'https://maps.app.goo.gl/C3cSCe9As3p4atCn6',
            alt: 'Alicia Nicotera cambia saldo en Saldo.com.ar'
        },
        {
            title: 'Very good.',
            name: 'Florencia Aguirre Fernández',
            content:
                'Very good... In each process they always help you and that is very good... I recommend it, in minutes I was able to make the transfer, everything was fast and reliable.',
            img: '/assets/landing-page/comments/safe-change-paypal-4',
            link: 'https://maps.app.goo.gl/XzaEJRMBTvwEwQz3A',
            alt: 'Florencia Aguirre Fernández cambia saldo en Saldo.com.ar'
        },
        {
            title: 'Very good tool.',
            name: 'Alfredo Lesquerre',
            content: 'Very good tool for moving funds globally.',
            img: '/assets/landing-page/comments/safe-change-paypal-5',
            link: 'https://maps.app.goo.gl/vwXeLw1gEsk63Maf8',
            alt: 'Alfredo Lesquerre cambia saldo en Saldo.com.ar'
        },
        {
            title: 'The most professional page.',
            name: 'Thiago Varas',
            // prettier-ignore
            content:
                "The most professional page I've ever met, responsible, attentive and with a diversity of services.",
            // prettier-ignore
            img: '/assets/landing-page/comments/safe-change-paypal-6',
            link: 'https://maps.app.goo.gl/ZQE2MGTeqm3iyNVk7',
            alt: 'Thiago Varas cambia saldo en Saldo.com.ar'
        },
        {
            title: 'The most professional',
            name: 'Brayan Torrealba',
            // prettier-ignore
            content:
            "The most professional page I've ever encountered. They are responsible, attentive, and offer a wide range of services. I highly recommend them.",
            // prettier-ignore
            img: '/assets/landing-page/comments/safe-change-paypal-7',
            link: 'https://maps.app.goo.gl/FhgqvwmQGZijHZJ16',
            alt: 'Brayan Torrealba cambia saldo en Saldo.com.ar'
        }
    ]
};
